import React from "react";
import {
  Section,
  HeaderSection,
  Title,
  UploadList,
} from "../primitives";
import FileDownloadRow from "../FileDownloadRow";
import RequestProForma from "../../pmc_rereg/make_payment_tab/RequestProForma";
const DownloadSection = ({ downloadFiles, regId }) => {
  if (!downloadFiles || downloadFiles.length === 0) {
    return null;
  }

  return (
    <Section>
      <HeaderSection>
        <Title>Downloads</Title>
      </HeaderSection>

      <UploadList>
        {downloadFiles.map((downloadConfig, index) => (
          <FileDownloadRow
            key={downloadConfig.value || index}
            downloadConfig={downloadConfig}
          />
        ))}
        <RequestProForma studentId={regId} />
      </UploadList>
    </Section>
  );
};

export default DownloadSection;

